












import 'reflect-metadata'
import { Vue, Component } from 'vue-property-decorator'
import Network from '@/js/Network'
import NetworkRow from './NetworkRow.vue'

@Component({
    components: {
        NetworkRow,
    },
})
export default class ListPage extends Vue {
    get networks(): Network[] {
        return this.$store.state.Network.networks
    }
}
